module.exports = __webpack_public_path__ + "img/br37.570d01e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br37.jpg
// module id = zMAh
// module chunks = 0